"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _tooltip = _interopRequireDefault(require("../tooltip"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-btn {\n  font-family: \"OpenSansRegular\";\n  border-radius: 0.1875rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  text-decoration: none;\n  border: none;\n  cursor: pointer;\n  background-color: #0561a7; }\n\n.bds-btn-primary {\n  background-color: #0561a7;\n  color: #ffffff; }\n  .bds-btn-primary:active, .bds-btn-primary:focus {\n    background-color: #0c5389; }\n  .bds-btn-primary:hover {\n    background-color: #007fe0; }\n\n.bds-btn-secondary {\n  border: 0.0625rem solid #8d8d8d;\n  background-color: transparent;\n  color: #393939; }\n  .bds-btn-secondary:active, .bds-btn-secondary:focus {\n    background-color: #c6c6c6; }\n  .bds-btn-secondary:hover {\n    background-color: #e0e0e0; }\n\n.bds-btn-textOnly {\n  background-color: transparent;\n  color: #393939; }\n  .bds-btn-textOnly:active, .bds-btn-textOnly:focus {\n    background-color: #c6c6c6; }\n  .bds-btn-textOnly:hover {\n    background-color: #e0e0e0; }\n\n.bds-btn-small {\n  height: 1.5rem;\n  font-size: 0.75rem;\n  padding-top: 0.125rem;\n  padding-bottom: 0.1875rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem; }\n\n.bds-btn-medium {\n  height: 2rem;\n  font-size: 0.875rem;\n  padding-top: 0.375rem;\n  padding-bottom: 0.4375rem;\n  padding-left: 1rem;\n  padding-right: 1rem; }\n\n.bds-btn-large {\n  height: 2.5rem;\n  font-size: 1rem;\n  padding-top: 0.625rem;\n  padding-bottom: 0.6875rem;\n  padding-left: 1rem;\n  padding-right: 1rem; }\n\n.bds-btn-primary.bds-btn-disabled {\n  cursor: not-allowed;\n  opacity: 70%; }\n  .bds-btn-primary.bds-btn-disabled:hover {\n    background-color: #0561a7; }\n\n.bds-btn-secondary.bds-btn-disabled {\n  cursor: not-allowed;\n  opacity: 35%; }\n  .bds-btn-secondary.bds-btn-disabled:hover {\n    background-color: transparent; }\n\n.bds-btn-textOnly.bds-btn-disabled {\n  cursor: not-allowed;\n  opacity: 35%; }\n  .bds-btn-textOnly.bds-btn-disabled:hover {\n    background-color: transparent; }\n";
  var fileName = "compone_button";
  var element = document.querySelector("style[data-sass-component='compone_button']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var ButtonWrapper = function ButtonWrapper(props) {
  var buttonComp = /*#__PURE__*/_react.default.createElement("button", {
    "data-testid": "button",
    className: (0, _classnames.default)(_objectSpread({}, props.btnClass)),
    onClick: props.onClick,
    disabled: props.disabled,
    type: props.type,
    value: props.value,
    name: props.name
  }, props.children);

  if (props.tooltipText) {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: props.tooltipText,
      position: props.tooltipPosition
    }, buttonComp));
  }

  return buttonComp;
};

var Button = function Button(_ref) {
  var _btnClass;

  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? _constants.defaultVariant : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? _constants.defaultSize : _ref$size,
      children = _ref.children,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      type = _ref.type,
      value = _ref.value,
      leftSVGIcon = _ref.leftSVGIcon,
      rightSVGIcon = _ref.rightSVGIcon,
      name = _ref.name,
      tooltipText = _ref.tooltipText,
      _ref$tooltipPosition = _ref.tooltipPosition,
      tooltipPosition = _ref$tooltipPosition === void 0 ? 'top' : _ref$tooltipPosition;
  var btnClass = (_btnClass = {}, _defineProperty(_btnClass, _constants.classes.button, true), _defineProperty(_btnClass, _constants.classes.buttonPrimary, variant === _constants.primaryProp), _defineProperty(_btnClass, _constants.classes.buttonSecondary, variant === _constants.secondaryProp), _defineProperty(_btnClass, _constants.classes.buttonTextOnly, variant === _constants.textOnlyProp), _defineProperty(_btnClass, _constants.classes.buttonSmall, size === _constants.smallProp), _defineProperty(_btnClass, _constants.classes.buttonMedium, size === _constants.mediumProp), _defineProperty(_btnClass, _constants.classes.buttonLarge, size === _constants.largeProp), _defineProperty(_btnClass, _constants.classes.disabled, disabled), _btnClass);
  var buttonProps = {
    btnClass: btnClass,
    onClick: onClick,
    disabled: disabled,
    type: type,
    value: value,
    name: name,
    tooltipText: tooltipText,
    tooltipPosition: tooltipPosition
  };
  return /*#__PURE__*/_react.default.createElement(ButtonWrapper, buttonProps, leftSVGIcon && !rightSVGIcon && /*#__PURE__*/_react.default.createElement("img", {
    src: leftSVGIcon,
    alt: "left Icon",
    style: {
      marginRight: _constants.iconBtnMargin
    }
  }), children, rightSVGIcon && /*#__PURE__*/_react.default.createElement("img", {
    src: rightSVGIcon,
    alt: "right Icon",
    style: {
      marginLeft: _constants.iconBtnMargin
    }
  }));
};

Button.propTypes = {
  variant: _propTypes.default.string,
  size: _propTypes.default.string,
  children: _propTypes.default.any,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  type: _propTypes.default.string,
  value: _propTypes.default.any,
  leftSVGIcon: _propTypes.default.any,
  rightSVGIcon: _propTypes.default.any,
  name: _propTypes.default.string,
  tooltipText: _propTypes.default.string,
  tooltipPosition: _propTypes.default.string
};
var _default = Button;
exports.default = _default;